import { Input, YesNoButton } from '../../../../components';
import { useValidation } from '../../../../hooks';
import { useFormContext } from 'react-hook-form';
import { claimFields } from '../../../../config';

import type { Dispatch, FC, SetStateAction } from 'react';
import { useContext } from 'react';
import { Localization } from '../../../../config/localization/localization';
import { LanguageSelectorContext } from '../../../../context/LanguageSelectorContext';

interface IAerialDamageProps {
  setSaveAndQuitChanges?: Dispatch<SetStateAction<Array<string>>>;
}

export const AerialDamage: FC<IAerialDamageProps> = ({ setSaveAndQuitChanges }) => {
  const formContext = useFormContext();
  const { fieldRequirements } = useValidation({});
  const { selectedLanguage } = useContext(LanguageSelectorContext);
  const localization = new Localization(selectedLanguage);

  const isDamageAerial: boolean | null = formContext.watch(claimFields.wasDamageAerial);

  const onAerialDamageNoClick = () => {
    setSaveAndQuitChanges?.((prev) => [...prev, 'FacilityNumber', claimFields.wasDamageAerial]);
    formContext.setValue(claimFields.facilityNumber, '');
    formContext.clearErrors(claimFields.wasDamageAerial);
    formContext.clearErrors(claimFields.facilityNumber);
  };

  const onFacilityNumberChange = () => {
    setSaveAndQuitChanges?.((prev) => [...prev, 'FacilityNumber', claimFields.wasDamageAerial]);
    formContext.setValue(claimFields.wasDamageAerial, true);
    formContext.clearErrors(claimFields.wasDamageAerial);
    formContext.clearErrors(claimFields.facilityNumber);
  };

  return (
    <div className={'flex w-full flex-col space-y-1'}>
      {/* WAS AERIAL? */}
      <YesNoButton
        isRequired
        isSelected={isDamageAerial}
        labelText={localization.translate('aerialDamage.wasAerialLabel')}
        name={claimFields.wasDamageAerial}
        onNoClick={onAerialDamageNoClick}
        onYesClick={() => setSaveAndQuitChanges?.((prev) => [...prev, claimFields.wasDamageAerial])}
        tooltip={localization.translate('aerialDamage.wasAerialTooltip')}
      />

      {/* PED POLE AMP (FACILITY NUMBER) */}
      {isDamageAerial !== false && (
        <Input
          inputOptions={{
            isRequired: fieldRequirements.FacilityNumber,
            label: localization.translate('aerialDamage.facilityNumberLabel'),
            name: claimFields.facilityNumber,
            onChange: onFacilityNumberChange,
          }}
          tooltip={localization.translate('aerialDamage.facilityNumberTooltip')}
        />
      )}
    </div>
  );
};